var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_957_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 32.5H18.2778V28.9444H21.8333V32.5ZM18.2778 20.0556H14.7222V28.9444H18.2778V20.0556ZM32.5 16.5H28.9444V23.6111H32.5V16.5ZM28.9444 12.9444H25.3889V16.5H28.9444V12.9444ZM7.61111 16.5H4.05556V20.0556H7.61111V16.5ZM4.05556 12.9444H0.5V16.5H4.05556V12.9444ZM16.5 4.05556H20.0556V0.5H16.5V4.05556ZM3.16667 3.16667V8.5H8.5V3.16667H3.16667ZM11.1667 11.1667H0.5V0.5H11.1667V11.1667ZM3.16667 24.5V29.8333H8.5V24.5H3.16667ZM11.1667 32.5H0.5V21.8333H11.1667V32.5ZM24.5 3.16667V8.5H29.8333V3.16667H24.5ZM32.5 11.1667H21.8333V0.5H32.5V11.1667ZM28.9444 28.9444V23.6111H21.8333V27.1667H25.3889V32.5H32.5V28.9444H28.9444ZM25.3889 16.5H18.2778V20.0556H25.3889V16.5ZM18.2778 12.9444H7.61111V16.5H11.1667V20.0556H14.7222V16.5H18.2778V12.9444ZM20.0556 11.1667V7.61111H16.5V4.05556H12.9444V11.1667H20.0556ZM7.16667 4.5H4.5V7.16667H7.16667V4.5ZM7.16667 25.8333H4.5V28.5H7.16667V25.8333ZM28.5 4.5H25.8333V7.16667H28.5V4.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_957_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr-icon.090d4f4cd48f8d1179c7d60711329c11.svg";
export { ForwardRef as ReactComponent };